export default "__VITE_ASSET__DvlN0vza__"